import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as realinfoActions from '../../../actions/realinfo';
import { validateIdcard } from '../../../utils';
import { MINMINAL_UPDATE_ID_CARD_LENGTH } from '../../../constants';
import ErrorMsg from '../../common_components/ErrorMsg';
import Agreement from '../../Agreement';

class UpdateRealinfo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			realnameError: null,
			idcardError: null,
			realName: '',
			idcard: '',
		};
	}

	componentWillReceiveProps(nextProps) {}

	handleSubmit(event) {
		event.preventDefault();
		if (this.validateInputs()) {
			this.props.updateRealinfo(this.state.realName, this.state.idcard);
		}
	}

	handleChangeName(event) {
		this.setState({ realName: event.target.value });
	}

	handleChangeIdcard(event) {
		this.setState({ idcard: event.target.value });
	}

	validate_realname(realname) {
		if (!realname) {
			this.setState({ realnameError: trans('error_realname') });
			return false;
		}
		return true;
	}

	validate_idcard(idcard) {
		if (!idcard) {
			this.setState({ idcardError: trans('error_idcard') });
			return false;
		} else if (idcard.length < MINMINAL_UPDATE_ID_CARD_LENGTH) {
			this.setState({ idcardError: trans('id_card_min_error') });
			return false;
		} else if (!validateIdcard(idcard)) {
			this.setState({ idcardError: trans('error_invalid_idcard') });
			return false;
		}
		return true;
	}

	validateInputs() {
		this.setState({
			realnameError: null,
			idcardError: null,
		});
		return (
			this.validate_realname(this.state.realName) &&
			this.validate_idcard(this.state.idcard)
		);
	}

	render() {
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{trans('UPDATE_ID_CARD_NUMBER')}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div
								className="content__sendinfo"
								id="J-sendinfo"
								style={{ 'padding-bottom': '5px' }}
							>
								{trans('input_real_info_hint')}
							</div>
							<div className="content__form">
								<form
									method="post"
									action=""
									id="J-validated-form"
									onSubmit={this.handleSubmit.bind(this)}
								>
									<div
										className="updateinfo-tip-wrap"
										style={{ padding: 0 }}
									>
										<div className="updateinfo-tip">
											<div className="updateinfo-tip__b">
												{trans('Note:')}{' '}
											</div>
											{trans('update_realinfo_hint')}{' '}
											<br />
										</div>
									</div>
									<div className="content__form-input">
										<input
											className="content__form-input-widget J-validated-field"
											placeholder={trans('Name')}
											maxLength="50"
											autoComplete="off"
											onChange={this.handleChangeName.bind(
												this
											)}
										></input>
									</div>
									<ErrorMsg
										error_msg={this.state.realnameError}
									/>
									<div className="content__form-input">
										<input
											className="content__form-input-widget J-validated-field"
											placeholder={trans('ID_Card_Number')}
											maxLength="50"
											onChange={this.handleChangeIdcard.bind(
												this
											)}
										></input>
									</div>
									<Agreement />
									<ErrorMsg
										error_msg={this.state.idcardError}
									/>
									<div className="content__submit-wrap">
										<input
											type="submit"
											className="content__submit"
											value={trans('SUBMIT')}
										></input>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		realinfo: state.realinfo,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, realinfoActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateRealinfo);



// WEBPACK FOOTER //
// ./app/components/security/realinfo/UpdateRealinfo.js